
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import store from './store';

// LightBootstrap plugin
import LightBootstrap from "./light-bootstrap-main";

// router setup
import routes from "./routes/routes";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Api from "./plugins/api.js";
import Helper from './plugins/helper.js';
import Request from "./plugins/request";

import QrcodeVue from 'qrcode.vue'
import PrimeVue from 'primevue/config'
import {PrimeIcons} from 'primevue/api';

import GmapVue from 'gmap-vue'


Vue.prototype.$store = store


import "./registerServiceWorker";
// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
Vue.use(VueAxios, axios);
Vue.use(Api);
Vue.use(Helper);
Vue.use(Antd);
Vue.use(Request);
Vue.use(QrcodeVue);
Vue.use(PrimeVue, {ripple: true});
Vue.use(PrimeIcons);
Vue.use(GmapVue, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    region: 'TR',
    language: 'tr',
    libraries: 'places',
  },
  dynamicLoad: false
})


window._axios = axios;

function decodeJWT(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch (_) {
    return null
  }
}

// configure router
const router = new VueRouter({
  routes,
  linkActiveClass: "nav-item active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

const PUBLIC_PATHS = ['/login', '/unauthorized', '/orphan-admin']

router.beforeEach((to, from, next) => {
  if (PUBLIC_PATHS.includes(to.path)) {
    next()
    return
  }

  const token = localStorage.getItem('access_token')
  if (!token) {
    next({ path: '/login' })
    return
  }

  if (to.meta && to.meta.requiresAuth) {
    const claims = decodeJWT(token)
    const roles = (claims && claims.roles) || []
    const isAdmin = roles.includes('organizationAdmin') || roles.includes('segmentAdmin')
    if (!isAdmin) {
      next({ path: '/login' })
      return
    }
  }

  next()
})

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data &&
      error.response.data.code === 'ORPHAN_ADMIN'
    ) {
      router.push('/orphan-admin')
    }
    return Promise.reject(error)
  }
)



/* eslint-disable no-new */
const $app = new Vue({
  el: "#app",
  store,
  render: (h) => h(App),
  router,
});

window._app = $app


